import { createApiClient } from "@unizen/shared/client";

const apiBase = import.meta.env.VITE_API_URL
  ? `${import.meta.env.VITE_API_URL}/api`
  : "/api";

export const api = createApiClient({
  baseUrl: apiBase,
  transport: "cookie",
});
